import {Component, EventEmitter, Input, Output} from '@angular/core';

import {SimpleWord} from '../../models/simple-word.model';
import {VoiceService} from '../../services/voice/voice.service';
import {GlobalEventService} from "../../services/global-event/global-event.service";

@Component({
  selector: 'app-word-play-btn',
  template: `
    <button type="button"
            *ngIf="word && word.wordVoice"
            class="option-btn type-1"
            (click)="playSound($event)">
      <i class="ic ic-listen {{ on ? 'on' : '' }}"></i>
    </button>
  `,
  styleUrls: ['./word-play-btn.component.scss'],
  host: { class: 'option-btn' },
})
export class WordPlayBtnComponent {
  @Input() word?: SimpleWord;
  @Output() play = new EventEmitter<MouseEvent>();

  constructor(
    protected voice: VoiceService,
    protected globalEventSvc: GlobalEventService,
  ) { }

  public playSound($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (!this.word) {
      throw new Error('WordPlayBtnComponent::playSound() word is undefined');
    }
    if (this.on) {
      this.voice.Stop();
    }
    else {
      this.voice.PlaySound(this.word).subscribe();
      this.play.emit($event);
    }
  }

  public get on(): boolean {
    return this.voice.on && this.voice.wordId === this.word?.id && this.voice.noEx === null;
  }
}
